module.exports = __webpack_public_path__ + "img/一站式安全服务5.bb0c9ade.jpg";